import Box from "@mui/material/Box";
import { STYLES } from "./ShoppingCartStyles";

interface WarningMessageProps {
  message: string;
}

export const WarningMessage: React.FC<WarningMessageProps> = ({ message }) => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
    <Box
      sx={{
        border: `1px solid ${STYLES.colors.warning}`,
        color: STYLES.colors.warning,
        fontFamily: STYLES.fontFamily,
        fontSize: '14px',
        textAlign: 'center',
        padding: '10px 16px',
        borderRadius: '4px',
        width: '100%',
      }}
    >
      {message}
    </Box>
  </Box>
);














